import Vuex from 'vuex';

const { mapState, mapGetters, mapActions } = Vuex;

export const projectComputed = {
  ...mapState('project', {
    currentProject: state => state.currentProject,
    games: state => state.games,
    maxDaysProgressionIsAvailable: state => state.currentProject ? state.currentProject.maxProjectDays ?? -1 : -1,
    lastProjectId: state => state.lastProjectId,
    starThresholds: state => state.currentProject ? state.currentProject.starThresholds ?? [] : []
  }),
  ...mapGetters('project', ['getGames', 'getGroupedGames', 'getProjectCode', 'getMaxBadges', 'getProjectId', 'getNumberOfProgressions', 'getProgressionData', 'getTotalProgressionTasks', 'getProgressionProgress', 'getAllProgressionTasks', 'getTotalDays','hasProgressionsEnabled']),
};

export const projectMethods = mapActions('project', ['fetchProject']);
